import { Page } from 'components';
import { useContext } from 'react';
import {  Results } from './components';
import { UserGroupsContext } from './UserGroupsContext';

let UserGroup = () => {
    let { isLoading } = useContext(UserGroupsContext);

    return (
        <Page
            isLoading={isLoading}
            useHeader={true}
            title="User Groups"
            addNewUrl="/admin/UserGroup/addnew"
        >
            <Results />
        </Page>
    )
}

export default UserGroup;